import _typeof from "@babel/runtime/helpers/typeof";
import c from "vue";
var p = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u",
  y = c.prototype.$isServer;
function l() {}
function d(n) {
  return n != null;
}
function r(n) {
  return typeof n == "function";
}
function o(n) {
  return n !== null && _typeof(n) == "object";
}
function b(n) {
  return o(n) && r(n.then) && r(n.catch);
}
function h(n, u) {
  var i = u.split("."),
    t = n;
  return i.forEach(function (f) {
    var e;
    t = o(t) && (e = t[f]) != null ? e : "";
  }), t;
}
function j(n) {
  return n == null || _typeof(n) != "object" ? !0 : Object.keys(n).length === 0;
}
export { h as get, p as inBrowser, d as isDef, j as isEmpty, r as isFunction, o as isObject, b as isPromise, y as isServer, l as noop };
